<template>
  <NuxtLink
    :class="[
      'flex h-full flex-col items-center justify-center p-2',
      active ? ' text-primary-500' : 'text-neutral-500',
    ]"
    :to="item.link"
  >
    <TIcon :name="item.iconName" class="h-6 w-6" />
    <span class="block text-xs">{{ item.label }}</span>
  </NuxtLink>
</template>

<script lang="ts" setup>
import { type NavigationItem } from '~/utils/NavigationItem';

const { $router } = useNuxtApp();

const props = defineProps<{
  item: NavigationItem;
}>();

const active = computed(() => {
  return (
    $router.currentRoute.value.path.startsWith(props.item.link) ||
    props.item.active
  );
});
</script>
